import script from "./contactFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./contactFooter.vue?vue&type=script&setup=true&lang=js"

import "./contactFooter.vue?vue&type=style&index=0&id=1044b200&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1044b200"]])

export default __exports__